import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Error from '../error/Error';
import * as classes from './Checkbox.module.scss';

export const CheckboxGroup = forwardRef(({ name, className, options, label, error, ...props }, ref) => (
  <div className={className}>
    <fieldset className={classes.checkboxGroup}>
      <legend>{label}</legend>

      {options.map(({ id, value, label }) => {
        return <CheckboxInput key={id} id={id} name={name} value={value} label={label} ref={ref} {...props} />;
      })}
    </fieldset>

    {error && <Error>{error?.message}</Error>}
  </div>
));
CheckboxGroup.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string
    })
  ),
  label: PropTypes.node,
  error: PropTypes.object
};

const Checkbox = forwardRef(({ error, ...props }, ref) => {
  return (
    <div>
      <CheckboxInput {...props} ref={ref} />
      {error && <Error>{error?.message}</Error>}
    </div>
  );
});
Checkbox.propTypes = {
  error: PropTypes.object
};

const CheckboxInput = forwardRef(
  (
    { id, name, value, onChange, checked, label, hideLabel, className, size = 'md', theme = 'purple', ...props },
    ref
  ) => {
    const checkboxLabel = classNames(classes.checkboxLabel, {
      [classes[`size__${size}`]]: size
    });
    const checkboxInput = classNames(classes.checkboxInput, {
      [classes[`theme__${theme}`]]: theme
    });

    return (
      <div className={classNames(classes.checkbox, className)}>
        <input
          id={id}
          name={name}
          value={value}
          className={checkboxInput}
          type="checkbox"
          onChange={onChange}
          checked={checked}
          ref={ref}
          {...props}
        />

        <label htmlFor={id} className={checkboxLabel}>
          {hideLabel ? <span className={classes.label__hidden}>{label}</span> : label}
        </label>
      </div>
    );
  }
);
CheckboxInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  label: PropTypes.string,
  hideLabel: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md']),
  theme: PropTypes.oneOf(['purple', 'teal'])
};

export default Checkbox;
